export default __webpack_public_path__ + "static/media/logo.f04f9775.png";